export function validateEmail(email) {
  let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function validateMobileNumber(phone) {
  let re = /^([0|\+[0-9]{1,5})?([7-9][0-9]{8})$/;
  return re.test(phone);
}

export function validateLocalPhoneNumber(phone) {
  let re = /^[0-9]{10}$/;
  return re.test(phone);
}
